import React, { useState, useEffect } from "react";
import styles from "./aside_menu.module.css";
import MobMenu from "../mob_menu/mob_menu";
import { SET_PORTAL_OVERLAY, RESET_PORTAL } from "../../../services/actions/portal_actions";
import { useDispatch } from "react-redux";

function AsideMenu() {

  const [showMenu, setShowMenu] = useState(false);

  const dispatch = useDispatch();

  const handleClicked = () => {
    if (showMenu) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
  }

  useEffect(() => {


    if (showMenu) {
      dispatch({ type: SET_PORTAL_OVERLAY });
    } else {
      dispatch({ type: RESET_PORTAL });
    }
    // eslint-disable-next-line
  }, [showMenu]);

  return (
    <div className={`${styles.menu} ${showMenu && styles.menuOpened}`}>
      <div className={`${showMenu ? styles.earOpened : styles.earClosed}`}
        onClick={handleClicked}
      />
      <MobMenu setShowMenu={setShowMenu} />
    </div>
  );
}

export default AsideMenu;
